import { orderBy } from 'lodash'
import getCollection from '../../utils/db/getCollection'

// const countries = [
//   { value: '1', label: 'США' },
//   { value: '2', label: 'Франція' },
//   { value: '3', label: 'Великобританія' },
//   { value: '4', label: 'Корея' },
//   { value: '5', label: 'Італія' },
//   { value: '6', label: 'Австралія' },
//   { value: '7', label: 'Південна Корея' },
//   { value: '8', label: 'Швеція' },
//   { value: '9', label: 'Іспанія' },
//   { value: '10', label: 'Німеччина' },
//   { value: '11', label: 'Україна' },
//   { value: '12', label: 'Швейцарія' },
//   { value: '13', label: 'Канада' },
//   { value: '14', label: 'Угорщина' },
//   { value: '15', label: 'Японія' },
//   { value: '16', label: 'Китай' },
// ]

const getOriginCountiesOptions = () =>
  getCollection({ path: 'brandsCountries', docIdName: 'id' }).then((res) =>
    orderBy(res, (c) => c.name.toLocaleLowerCase(), ['asc']).map((c) => ({
      value: c.id,
      label: c.name,
    }))
  )

export default getOriginCountiesOptions
